export const locale = {
    lang: 'en',
    data: {
        APP_SWITCHER_DIALOG: {
            SWITCH_MODULE: 'Switch module',
            CLOSE: 'CLOSE'
        }
    }
};
